module.exports = __webpack_public_path__ + "img/icon-choose-image.b612b2a4.svg";